module.exports = __webpack_public_path__ + "static/media/Avatar-no-gender.7f42d268.png";